import React from "react";
import { Capacity, ExplorationType, Perspective, UIState } from "../../App";
import CapacityPanel from "./capacity-panel/CapacityPanel";
import CharacterPanel from "./character-panel/CharacterPanel";
import './MainPanel.scoped.scss';
import PanelMenu from "./panel-menu/PanelMenu";
import PerspectivePanel from "./perspective-panel/PerspectivePanel";

interface ComponentProps {
    didClickOnPanelMenu: (newState: UIState) => void;
    didClickOnLearnMore: (capacity: Capacity) => void;
    didClickOnLearnMorePerspective: (perspective: Perspective) => void;
    didClickOnCapacity: (capacity: Capacity) => void;
    didClickOnPerspective: (perspective: Perspective) => void;
    presentModalContent: (content: JSX.Element) => void;
    uiState: UIState;
    openedCapacity: Capacity;
    openedPerspective: Perspective;
}

class MainPanel extends React.Component<ComponentProps, any> {
    private didClickOnCloseCapacity = () => {
        this.props.didClickOnCapacity(Capacity.General);
    }

    private didClickOnClosePerspective = () => {
        this.props.didClickOnPerspective(Perspective.General);
    }

    render() {
        let uiStateClass = (this.props.uiState === UIState.Intro) ? "" : "fullWidth";
        return (
            <div className={'main-panel-wrp ' + uiStateClass}>
                <PanelMenu onClickHandler={this.props.didClickOnPanelMenu} uiState={this.props.uiState} onClickClose={this.didClickOnCloseCapacity}
                    category={this.props.openedCapacity} explorationType={ExplorationType.Capacities}></PanelMenu>
                <CapacityPanel uiState={this.props.uiState} openedCapacity={this.props.openedCapacity}
                    didClickOnLearnMore={this.props.didClickOnLearnMore}
                    presentModalContent={this.props.presentModalContent}
                    didClickOnCapacity={this.props.didClickOnCapacity}
                ></CapacityPanel>

                <div className="topPanel-tablet"></div>

                <CharacterPanel uiState={this.props.uiState} openedCapacity={this.props.openedCapacity} openedPerspective={this.props.openedPerspective}
                    didClickOnCapacity={this.props.didClickOnCapacity}
                    didClickOnPerspective={this.props.didClickOnPerspective}
                ></CharacterPanel>

                <PerspectivePanel uiState={this.props.uiState} openedPerspective={this.props.openedPerspective}
                    didClickOnLearnMore={this.props.didClickOnLearnMorePerspective}
                    presentModalContent={this.props.presentModalContent}
                    didClickOnPerspective={this.props.didClickOnPerspective}
                ></PerspectivePanel>
                <PanelMenu onClickHandler={this.props.didClickOnPanelMenu} uiState={this.props.uiState} onClickClose={this.didClickOnClosePerspective}
                    perspective={this.props.openedPerspective} explorationType={ExplorationType.Perspectives}></PanelMenu>
            </div>
        )
    }
}

export default MainPanel;